// src/App.tsx

import './App.css';

import React from 'react';

import MayaThorDoubleSwapGrid from './components/doubleSwapGrid';

const App: React.FC = () => {
 
  return (
    <div className="container" >
     <div className="row mt-3">
        <div className="col-md">
          <MayaThorDoubleSwapGrid />
        </div>
      </div>
    </div>
  );
}

export default App;
